module.exports = __webpack_public_path__ + "img/12.3ffc8650.jpg";